export default (choices, inputValue) => {
  const selectedPair = choices.find(({ value }) => value === inputValue)
  if (selectedPair === undefined) {
    return ''
  }
  const { label } = selectedPair
  return label
}
